import { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  green6,
  grey1,
  grey10,
  grey2,
  grey5,
  purple1,
  purple2,
  red6,
} from 'approot/shared/styles/colours.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { InteractiveDragItem } from './interactive-drag.style';

type InteractiveDropItemTargetProps = {
  $isOver?: boolean;
  $canDrop?: boolean;
  $hasDropped?: boolean;
  $isCorrect?: boolean;
};

export const baseDropItemCss = css<InteractiveDropItemTargetProps>`
  background-color: ${grey2};
  border: 2px dashed ${grey5};
  border-radius: ${rem(borderRadius8)};
  box-shadow: 0 0 1px 4px rgba(0, 0, 0, 0);
  color: ${grey5};
  flex-wrap: wrap;
  font-size: ${rem(40)};
  position: relative;

  &:before {
    content: '?';
    position: absolute;
    left: 50%;
    margin-left: -${rem(12)};
  }

  ${({ $hasDropped }) =>
    $hasDropped &&
    `
    border: none;
    &:before {
      content: '';
    }
  `}

  ${({ $canDrop, $isOver }) =>
    $canDrop &&
    !$isOver &&
    `
    background-color: ${purple1};
    border-color: ${grey10};
  `}
   
  ${({ $isOver }) =>
    $isOver &&
    `
    background-color: ${purple2};
    border-color: ${grey10};
    color: ${grey1};
  `}

  ${({ $isCorrect }) =>
    $isCorrect === true &&
    `
    box-shadow: 0 0 1px 4px ${green6};
    transition: box-shadow 500ms ease; 
  `}
  ${({ $isCorrect }) =>
    $isCorrect === false &&
    `
    box-shadow: 0 0 1px 4px ${red6};
    transition: box-shadow 500ms ease; 
  `}

  ${InteractiveDragItem} {
    &:focus {
      outline: 3px solid ${grey10};
      outline-offset: 6px;
    }
  }
`;
